<template>
    <div>
        <v-dialog persistent v-model="dialog" :width="450">
            <v-card style="max-height:90vh" tile>
                <v-toolbar :style="{backgroundColor: item && item.color ? item.color : ''}">
                    <v-toolbar-title class="text-primary text-truncate">{{ item.title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="$emit('delete', item)" icon>
                        <v-icon color="primary" size="21">delete</v-icon>
                    </v-btn>
                    <v-btn @click="$emit('edit', item)" icon>
                        <v-icon color="primary" size="21">edit</v-icon>
                    </v-btn>
                    <v-btn @click="dialog = false" icon>
                        <v-icon color="primary" size="21">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="pt-4 px-5">
                    <v-row justify="space-between" align="center" class="ma-0">
                        <v-col cols="auto" class="pa-0">
                            <div class="text-meta rounded" v-if="item.start_date"><v-icon size="16" class="me-1 mb-1">calendar_month</v-icon>{{ item.start_date.format('jYYYY/jMM/jDD') }}</div>
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <p class="text-small d-inline-block mb-0" v-if="item.start_date"><v-icon size="17" class="me-1">update</v-icon>{{ item.start_date.format('HH:mm') }}</p>
                            <p class="text-small d-inline-block mb-0 mx-2 text-grey-darken-1" v-if="item && Object.hasOwn(item, 'end_date')">الی</p>
                            <p class="text-small d-inline-block mb-0" v-if="item && Object.hasOwn(item, 'end_date') && item.end_date">{{ item.end_date.format('HH:mm') }}</p>
                        </v-col>
                    </v-row>
                    <div style="width:100%; height:1px; background-color:#eee;" class="my-2"></div>
                    <div style="min-height:20vh; max-height:35vh; overflow-y:auto; scrollbar-width: thin">
                        <div class="text-meta" v-if="item && Object.hasOwn(item, 'description') && item.description" style="white-space: pre-wrap;">{{ item.description }}</div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            item: {},
        };
    },
    methods: {
        open(item){
            this.item = {...item};
            this.dialog = true;
        }
    },
};
</script>
